import { Box, Stack } from "@mui/material";

export const ChartGrid = ({ amountLines = 6, height = 337.5 }: { amountLines?: number; height?: number }) => {
    const renderGrid = () => {
        const gridLines = [];
        for (let i = 1; i <= amountLines; i++) {
            gridLines.push(
                <Box
                    key={i}
                    data-testid={"grid-line"}
                    sx={{
                        position: "relative",
                        top: "1px",
                        width: "100%",
                        height: "1.1px",
                        backgroundImage: `repeating-linear-gradient(90deg, #aaa, #aaa 2px, transparent 2px, transparent 4px)`,
                    }}
                />,
            );
        }
        return gridLines;
    };

    return (
        <Stack
            style={{
                position: "absolute",
                left: "16px",
                bottom: 0,
                right: "16px",
                justifyContent: "space-between",
                height,
            }}
        >
            {renderGrid()}
        </Stack>
    );
};
